/**
 * @components login
 * @author 陈恩浩
 */

import React, { Component } from 'react'
import { Input, Select } from 'antd'
import { postLogin } from 'src/apis/user'
import { changePopup } from 'src/redux/basicInfo'
import { connect } from 'react-redux'
import { withTranslation } from 'react-i18next';

import './index.scss'
const { Option } = Select

@withTranslation()
@connect((state) => state, { changePopup })
class Login extends Component {
  constructor(props) {
    super(props)
    this.state = {
      phone: '',
      pwd: '',
    }
  }

  componentDidMount() { }

  handleClickRetrieve = () => {
    this.props.changePopup({ type: 'retrieve', status: true })
  }

  handleChangePhone = (e) => {
    // console.log(e.target.value)
    let phone = e.target.value
    this.setState({ phone })
  }

  handleChangepassword = (e) => {
    // console.log(e.target.value)
    let pwd = e.target.value
    this.setState({ pwd })
  }

  handleLogin = () => {
    let { phone, pwd } = this.state
    if (phone && pwd) {
      postLogin({ phone, pwd }).then((res) => {
        console.log(res)
      })
    }
  }

  onFinish = (values) => {
    console.log('Received values of form: ', values)
  }

  render() {
    let { t } = this.props;
    const options = [
      {
        value: 'US+1',
        label: 'US+1',
      },
      {
        value: 'US+21',
        label: 'US+21',
      },
    ]
    return (
      <div className="login">
        <div className="login-layout">
          <div className="text">手机号/Phone</div>
          <Select defaultValue="CN+86">
            {options.map((item, index) => (
              <Option key={'select-' + index} value={item.value}>
                {item.label}
              </Option>
            ))}
          </Select>
          <Input maxLength="11" onChange={this.handleChangePhone}></Input>
        </div>
        <div className="login-layout-extra"></div>
        <div className="login-layout">
          <div className="text">密码/Password</div>
          <Input.Password
            style={{ width: '230px' }}
            maxLength="32"
          ></Input.Password>
        </div>
        <div className="login-layout-extra">
          <div className="extra-left"></div>
          <div className="extra-right">
            <span
              className="extra-right__password"
              onClick={this.handleClickRetrieve}
            >
              {t('popout:login_forget')}
            </span>
          </div>
        </div>
        <div className="login-button" onClick={this.handleLogin}>
          {t('popout:login_button')}
        </div>
      </div>
    )
  }
}

export default Login
